import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ArrowRight } from '@outdoor-voices/ui';
import { Fragment } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import { dayMonthDateShort, monthDayYear } from '../../utils/dates/toString';
import { ERROR_STATUSES as ERROR_STATES } from './constants';
import { itemsToProducts } from './itemsToProducts';
import css from './Tracker.module.scss';
import Ovly from '../Ovly';
import Product from './Product';
import ProgressBar from './ProgressBar';
import rtrim from '../../utils/strings/rtrim'; // status constants

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
var UNKNOWN = 'unknown';
var DELIVERED = 'delivered';
var PRE_TRANSIT = 'pre_transit';
var OUT_FOR_DELIVERY = 'out_for_delivery';
var STATUS_MESSAGES = {
  unknown: 'Processing',
  pre_transit: 'Processing',
  in_transit: '',
  out_for_delivery: 'Arriving: Today',
  available_for_pickup: '',
  return_to_sender: '',
  failure: '',
  cancelled: '',
  error: '',
  delivered: 'Delivered!'
}; // ops request to make dhl carrier str more readable

var DHL_CARRIERS = ['DHLGlobalMail', 'DHLGlobalmailInternational'];
var DHL_DISPLAY_NAME = 'DHL eCommerce';

var getDisplayCarrier = function getDisplayCarrier(carrierStr) {
  if (DHL_CARRIERS.indexOf(carrierStr) > -1) {
    return DHL_DISPLAY_NAME;
  }

  return carrierStr;
};

var getDateTime = function getDateTime(dateStr) {
  return new Date(rtrim(dateStr, ['Z'])).toLocaleTimeString([], {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
}; // bandaid for shopify/ns endpoint bad dateStr in some browsers


var fixDateStr = function fixDateStr(str) {
  var parts = str.split(' ');

  if (parts.length < 3) {
    return "".concat(parts.join('T'), ".000");
  }

  return "".concat(parts[0], "T").concat(parts[1], ".000");
};

var toTitleCase = function toTitleCase(str) {
  if (!str) {
    return false;
  }

  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

var LocationDisplay = function LocationDisplay(_ref) {
  var city = _ref.city,
      state = _ref.state;
  var formattedCity = toTitleCase(city);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formattedCity && formattedCity, formattedCity && state && ', ', state && state, !formattedCity && !state && /*#__PURE__*/_jsx("span", {
      children: "US"
    })]
  });
};

LocationDisplay.defaultProps = {
  city: false,
  state: false
};
LocationDisplay.propTypes = {
  city: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  state: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};

var InfoLine = function InfoLine(_ref2) {
  var copy = _ref2.copy;
  return /*#__PURE__*/_jsx("p", {
    className: css.infoLine,
    children: copy
  });
};

InfoLine.propTypes = {
  copy: PropTypes.string.isRequired
};

var Address = function Address(_ref3) {
  var title = _ref3.title,
      address = _ref3.address;
  var lines = address.split('\n');

  if (lines[0] === lines[1]) {
    lines.shift();
  }

  return /*#__PURE__*/_jsxs("li", {
    className: css.infoBlock,
    children: [/*#__PURE__*/_jsx("h2", {
      className: css.title,
      children: title
    }), lines.map(function (line) {
      return /*#__PURE__*/_jsx(InfoLine, {
        copy: line
      }, line);
    })]
  });
};

Address.propTypes = {
  title: PropTypes.string,
  address: PropTypes.string
};

var Tracker = function Tracker(_ref4) {
  var bopis = _ref4.bopis,
      cancelled = _ref4.cancelled,
      cancelledAt = _ref4.cancelledAt,
      fulfillmentStatus = _ref4.fulfillmentStatus,
      loading = _ref4.loading,
      _ref4$tracker = _ref4.tracker,
      trackerCarrier = _ref4$tracker.carrier,
      trackingCode = _ref4$tracker.tracking_code,
      _ref4$tracker$status = _ref4$tracker.status,
      initialStatus = _ref4$tracker$status === void 0 ? UNKNOWN : _ref4$tracker$status,
      trackingDetails = _ref4$tracker.tracking_details,
      estDeliveryDate = _ref4$tracker.est_delivery_date,
      publicUrl = _ref4$tracker.public_url,
      trackingUrl = _ref4.tracking_url,
      items = _ref4.items,
      orderName = _ref4.order_name,
      orderDate = _ref4.order_date,
      shippingAddress = _ref4.shipping_address,
      billingAddress = _ref4.billing_address,
      transactions = _ref4.transactions;
  var status = cancelled ? 'cancelled' : initialStatus;
  var hasOrderError = ERROR_STATES.indexOf(status) > -1; // get the status title from status + delivery date

  var showEstDelivery = estDeliveryDate && status !== DELIVERED && status !== OUT_FOR_DELIVERY;
  var dayAndMonthFormattedDate = showEstDelivery && dayMonthDateShort(new Date(estDeliveryDate));
  var useStatusTitle = status === UNKNOWN || status === PRE_TRANSIT || status === OUT_FOR_DELIVERY || status === DELIVERED;
  var title = useStatusTitle ? STATUS_MESSAGES[status] : '';

  if (showEstDelivery) {
    title = "Arriving ".concat(dayAndMonthFormattedDate);
  }

  if (cancelled) {
    title = 'Order Cancelled';
  }

  if (hasOrderError) {
    title = 'Order Status';
  }

  if (bopis && fulfillmentStatus === 'fulfilled') {
    title = 'Picked Up!';
  }

  var trackShipmentUrl = publicUrl || trackingUrl;
  var products = itemsToProducts(items);
  var hasProducts = products.length > 0;
  var hasTrackingDetails = !bopis && trackingDetails && trackingDetails.length > 0;
  var carrier = getDisplayCarrier(trackerCarrier);
  var details = hasTrackingDetails ? _toConsumableArray(trackingDetails).reverse() : null;

  var progressBar = /*#__PURE__*/_jsx(ProgressBar, {
    bopis: bopis,
    fulfillmentStatus: fulfillmentStatus,
    hasOrderError: hasOrderError,
    loading: loading,
    status: status
  });

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("ul", {
      className: css.info,
      children: [/*#__PURE__*/_jsxs("li", {
        className: css.infoBlock,
        children: [/*#__PURE__*/_jsx("h2", {
          className: css.title,
          children: "Order Details"
        }), orderName && /*#__PURE__*/_jsx(InfoLine, {
          copy: "Order Number: ".concat(orderName)
        }), orderDate && /*#__PURE__*/_jsx(InfoLine, {
          copy: "Order Placed: ".concat(monthDayYear(new Date(fixDateStr(orderDate))))
        }), cancelledAt && /*#__PURE__*/_jsx(InfoLine, {
          copy: "Order Cancelled: ".concat(monthDayYear(new Date(fixDateStr(cancelledAt))))
        }), transactions && transactions.map(function (_ref5, idx) {
          var amount = _ref5.amount,
              details = _ref5.details,
              giftCard = _ref5.giftCard;
          return /*#__PURE__*/_jsxs(Fragment, {
            children: [details && /*#__PURE__*/_jsx(InfoLine, {
              // eslint-disable-next-line max-len
              copy: "Paid With: ".concat(details.credit_card_company, " (ending in ").concat(details.credit_card_last_four_digits, ") - ").concat(amount)
            }, details.credit_card_last_four_digits), giftCard && /*#__PURE__*/_jsx(InfoLine, {
              // eslint-disable-next-line max-len
              copy: "Paid With: Gift Card (ending in ".concat(giftCard.last_four_characters, ") - ").concat(amount)
            }, giftCard.last_four_characters)]
          }, idx);
        })]
      }), shippingAddress && /*#__PURE__*/_jsx(Address, {
        title: "".concat(bopis ? 'Pick Up' : 'Shipping', " Address"),
        address: shippingAddress
      }), !shippingAddress && /*#__PURE__*/_jsx("li", {
        className: css.infoBlock,
        "aria-busy": "true"
      }), /*#__PURE__*/_jsx(Address, {
        title: "Billing Address",
        address: billingAddress
      }), /*#__PURE__*/_jsx("li", {
        className: cc([css.infoBlock, css.trackingBlock]),
        children: trackShipmentUrl && /*#__PURE__*/_jsxs("a", {
          className: css.arrowLink,
          href: trackShipmentUrl,
          rel: "noopener noreferrer",
          target: "_blank",
          children: ["Track Shipment", /*#__PURE__*/_jsx(ArrowRight, {})]
        })
      })]
    }), !loading && /*#__PURE__*/_jsxs("div", {
      className: css.orderStatus,
      children: [/*#__PURE__*/_jsxs("h2", {
        className: css.statusTitle,
        children: [title, hasTrackingDetails && /*#__PURE__*/_jsxs(Ovly, {
          button: /*#__PURE__*/_jsxs("div", {
            className: css.arrowLink,
            children: ["Shipment Details", /*#__PURE__*/_jsx(ArrowRight, {})]
          }),
          ariaLabelledBy: "shipping-details",
          label: "Shipment Details",
          medium: true,
          children: [/*#__PURE__*/_jsx("h2", {
            className: cc([css.title, css.detailsTitle]),
            id: "shipping-details",
            children: "Shipping Details"
          }), carrier && /*#__PURE__*/_jsx(InfoLine, {
            copy: carrier
          }), trackingCode && /*#__PURE__*/_jsx(InfoLine, {
            copy: "Tracking NO: ".concat(trackingCode)
          }), /*#__PURE__*/_jsx("ul", {
            className: css.detailsList,
            children: details.map(function (_ref6) {
              var datetime = _ref6.datetime,
                  message = _ref6.message,
                  location = _ref6.tracking_location;
              return /*#__PURE__*/_jsxs("li", {
                className: css.detailsItem,
                children: [/*#__PURE__*/_jsx("p", {
                  className: cc([css.detailsCopy, css.datetime]),
                  children: getDateTime(datetime)
                }), /*#__PURE__*/_jsx("p", {
                  className: cc([css.detailsCopy, css.location]),
                  children: /*#__PURE__*/_jsx(LocationDisplay, _objectSpread({}, location))
                }), /*#__PURE__*/_jsx("p", {
                  className: cc([css.detailsCopy, css.message]),
                  children: message
                })]
              }, message);
            })
          })]
        })]
      }), progressBar]
    }), loading && /*#__PURE__*/_jsx("div", {
      "aria-busy": "true",
      children: /*#__PURE__*/_jsxs("div", {
        className: css.orderStatus,
        children: [/*#__PURE__*/_jsx("h2", {
          className: css.statusTitle,
          children: "Loading..."
        }), progressBar]
      })
    }), hasProducts && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("h2", {
        className: css.productsTitle,
        children: "Items Ordered"
      }), /*#__PURE__*/_jsx("ul", {
        className: css.products,
        children: products.map(function (product, idx) {
          return /*#__PURE__*/_createElement(Product, _objectSpread(_objectSpread({}, product), {}, {
            key: "".concat(idx, "-").concat(product.variantId)
          }));
        })
      })]
    })]
  });
};

Tracker.defaultProps = {
  cancelled: false,
  cancelledAt: false,
  loading: false,
  items: []
};
Tracker.propTypes = {
  billing_address: PropTypes.string.isRequired,
  bopis: PropTypes.bool,
  cancelled: PropTypes.bool,
  cancelledAt: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  fulfillmentStatus: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape()),
  loading: PropTypes.bool,
  order_date: PropTypes.string.isRequired,
  order_name: PropTypes.string.isRequired,
  transactions: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.shape())]).isRequired,
  shipping_address: PropTypes.string.isRequired,
  tracker: PropTypes.shape({
    carrier: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    tracking_code: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    status: PropTypes.string.isRequired,
    tracking_details: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    est_delivery_date: PropTypes.string.isRequired,
    public_url: PropTypes.string.isRequired
  }).isRequired,
  tracking_url: PropTypes.string.isRequired
};
export default Tracker;